"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceConnectRouter = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var DeviceAuthContextProvider_1 = require("../providers/DeviceAuthContextProvider");
var DeviceConnectRouter = function (_a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    return (0, react_router_dom_1.useRoutes)([
        {
            path: '/connect/:hash',
            element: react_1.default.createElement(ConnectRouteElement, { onSuccess: onSuccess, onFailure: onFailure }),
        },
    ]);
};
exports.DeviceConnectRouter = DeviceConnectRouter;
var ConnectRouteElement = function (_a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    var ctx = react_1.default.useContext(DeviceAuthContextProvider_1.DeviceAuthContext);
    if (!ctx) {
        throw new Error('<DeviceConnectRouter /> must be placed within <DeviceAuthContextProvider />');
    }
    react_1.default.useLayoutEffect(function () {
        if (ctx.isInitialized) {
            if (ctx.isAuthenticated && onSuccess) {
                onSuccess(ctx.device);
            }
            if (!ctx.isAuthenticated && onFailure) {
                onFailure();
            }
        }
    }, [ctx.isInitialized, ctx.isAuthenticated, ctx.device, onSuccess, onFailure]);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
// ----------------------------------------------------------------------
